<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Brands Challenges</p>
        </div>
        <el-tabs type="border-card" v-model="active">
          <el-tab-pane label="TikTok" name="tiktok">
            <TikTokTable :challenge_type="type"/>
          </el-tab-pane>
          <el-tab-pane label="Instagram" name="instagram">
            <InstagramTable :challenge_type="type"/>
          </el-tab-pane>
          <el-tab-pane label="YouTube Shorts" name="shorts">
            <ShortsTable :challenge_type="type"/>
          </el-tab-pane>
          <el-tab-pane label="YouTube Regular" name="youtube">
            <YouTubeRegularTable :challenge_type="type"/>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import TikTokTable from "../components/TikTokTable";
import InstagramTable from "../components/InstagramTable";
import ShortsTable from "../components/ShortsTable";
import YouTubeRegularTable from "../components/YouTubeRegularTable";
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      budget:0,
      active: 'tiktok',
      type:'brand'
    }
  },
  components: {
    YouTubeRegularTable,
    TikTokTable,
    ShortsTable,
    InstagramTable
  },

  computed: {
    ...mapState('challenges', ['wallet','loading','music_challenges']),
  },

  methods: {
    resetState() {
      // Call reset method on each child component
      this.$store.commit('challenges/reset')
      this.$store.commit('instagram/reset')
      this.$store.commit('youtubeShorts/reset')
      this.$store.commit('youtubeRegular/reset')
    }
  },
  beforeRouteLeave(to, from, next) {
    //  reset the state of all child components
    this.resetState()
    next()
  },
  created() {
  }
}
</script>
<style>
i.fas.fa-dollar-sign{
  font-size: 15px !important;
  padding-right: 2px !important;
}
.budget{
  margin-left: 5px;
}
</style>
